// Utils
import { toInteger } from 'ezyvet-fe-helpers';
/**
 * @description Takes a time in seconds and converts into a format the shows
 *              the number of days, hours and minutes that the seconds represent.
 *
 * @example convertSecondsToStopwatchFormat(1800) = '00:30'
 *
 * @param {number} timeInSecondsAsADecimal The amount of seconds to be translated to a label
 * @returns {string} string formatted as {days} d {hours} h {minutes} m
 */
export var convertSecondsToStopwatchFormat = function (timeInSecondsAsADecimal) {
    if (timeInSecondsAsADecimal <= 0) {
        return '00:00';
    }
    var timeInSeconds = toInteger(timeInSecondsAsADecimal);
    var daysElapsed = Math.floor(timeInSeconds / 24 / 60 / 60);
    if (daysElapsed > 99) {
        return '99+ days';
    }
    var hoursElapsed = Math.floor((timeInSeconds / 60 / 60) % 24);
    var minutesElapsed = Math.floor((timeInSeconds / 60) % 60);
    var dayLabel = daysElapsed ? ("" + daysElapsed).padStart(2, '0') : '';
    var hourLabel = hoursElapsed ? ("" + hoursElapsed).padStart(2, '0') : '00';
    var minuteLabel = minutesElapsed ? ("" + minutesElapsed).padStart(2, '0') : '00';
    return [dayLabel, hourLabel, minuteLabel].filter(function (label) { return label; }).join(':');
};
//# sourceMappingURL=convertSecondsToStopwatchFormat.js.map